import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { appStr } from 'src/locales/app_strings';
import { Box, ListItem, ListItemText } from '@mui/material';
import { getThumb, getImg } from 'src/services/AssetApi';
import ZoomImage from 'src/components/zoom-image';
import PaginatedList from 'src/components/ui/list/paginated-list';
import HeaderCellText from 'src/components/ui/list/header-cell-text';

export const ListView = (props) => {
  const {
    dataStore,
    onPageChange = () => {},
    onRowsPerPageChange,
    page = 0,
    rowsPerPage = 0,
    onDetailClicked,
  } = props;

  const { t } = useTranslation();

  const renderItem = (item, rowstyle) => (
    <>
      <ListItem
        divider={true}
        key={item.id}
        sx={rowstyle}
        onClick={() => onDetailClicked(item)}
      >
        <ListItemText sx={{ width: '30%', color: 'primary.main' }}>{item.paidDay}</ListItemText>
        <ListItemText sx={{ width: '30%' }}>{item.plateNumber}</ListItemText>
        <ListItemText sx={{ width: '25%', textAlign: 'center' }}>{item.quantity}</ListItemText>
        <ListItemText 
          sx={{ width: '15%', textAlign: 'right' }} 
          onClick={(event) => event.stopPropagation()} // Prevent ListItem onClick
        >
          {item.fileName && (
            <ZoomImage
              thumbSrc={getThumb(item.fileName)}
              zoomSrc={getImg(item.fileName)}
              alt={item.id}
            />
          )}
        </ListItemText>
      </ListItem>
    </>
  );

  return (
    <Box sx={{ position: 'relative' }}>
      <PaginatedList
        items={dataStore.items}
        loading={dataStore.loading}
        renderItem={renderItem}
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      >
        <HeaderCellText sx={{width: '30%'}}>{t(appStr.txt_030)}</HeaderCellText>
        <HeaderCellText sx={{width: '30%'}}>{t(appStr.txt_034)}</HeaderCellText>
        <HeaderCellText sx={{width: '25%', textAlign: 'center'}}>{t(appStr.txt_036)}</HeaderCellText>
        <HeaderCellText sx={{ width: '15%', textAlign: 'right' }} />
      </PaginatedList>
    </Box>
  );
};

ListView.propTypes = {
  dataStore: PropTypes.object,
  onDeselectAll: PropTypes.func,
  onDeselectOne: PropTypes.func,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  onSelectAll: PropTypes.func,
  onSelectOne: PropTypes.func,
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  selected: PropTypes.array,
};
